jQuery(function ($) {
  $('.js-accordion-toggle').on('click', function () {
    $(this).closest('.accordion__item').toggleClass('accordion__item--open');
    $(this).next('.accordion__body').slideToggle(200);
  });
  $('.js-accordion-more').on('click', function () {
    $(this).closest('.accordion__item').hide();
    $('.accordion__item--hidden').fadeIn().removeClass('accordion__item--hidden');
  });
});
